import { mapState, mapMutations, mapActions } from 'vuex';

export const mouseEventMixins = {
  data() {
    return {};
  },
  methods: {
    ...mapMutations({
      setCurrentIndexInPage: 'card/setCurrentIndexInPage',
    }),
    handleMouseEnter() {
      !this.isPreview && (this.showTopicEditorBox = true);
      this.setStackIndex();
    },
    setStackIndex() {
      this.setCurrentIndexInPage(this.msg.currentIndexInPage);
    },
  },
};
